// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3C1_L","right":"styles_right__2ihsD"};